import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FilterPane } from './FilterPane';
import { NavBar } from './NavBar';
import { ActivityCardTable } from './ActivityCardTable';
import { ActivityCardContainer } from './ActivityCardContainer';
import '../styles/hcHomepageStyles.css';

export class ActivityPage extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: [],
        };
    }

    tagsAndFiltersMatch = (tags) => {
        const tagsAndFilters = tags.concat(this.state.filters);
        /* If the array and the set are the same size, then there are no duplicates.
        If there are no duplicates, then the tags don't match the filters */
        return (new Set(tagsAndFilters)).size !== tagsAndFilters.length;
    };
    
    filterCards = (cards) => {
        if (this.state.filters.includes('allActivities')) {
            return cards;
        }
        return cards.filter(card => this.tagsAndFiltersMatch(card.activityTypes));
    };
    

    drawActivityCardContainers = filteredCards => filteredCards.map((card, index) =>
        (<ActivityCardContainer
            key={`${card.cardName}_${index + 1}`}
            card={card}
            activityCardText={this.props.activityCardText}
        />));

    addFilter = (filter) => {
        const filterList = this.state.filters;
        filterList.push(filter);
        this.setState({
            filters: filterList,
        });
    }

    removeFilter = (filter) => {
        const filterList = this.state.filters;
        const filterIndex = filterList.indexOf(filter);
        filterList.splice(filterIndex, 1);
        this.setState({
            filters: filterList,
        });
    }
    
    render() {
        return (
            <div className="activityPage">
                <NavBar 
                    handleHomeClick={this.props.handleHomeClick}
                />
                <FilterPane
                    skillName={this.props.skill.skillName}
                    toolTipText={this.props.toolTipText}
                    pdfURL={this.props.skill.pdfURL}
                    addFilter={this.addFilter}
                    removeFilter={this.removeFilter}
                    currentFilters={this.state.filters}
                    filterButtonText={this.props.filterButtonText}
                />
                <ActivityCardTable>
                    {this.drawActivityCardContainers(this.filterCards(this.props.skill.cards))}
                </ActivityCardTable>
            </div>
        );
    }   
}

ActivityPage.propTypes = {
    skill: PropTypes.object.isRequired,
    handleHomeClick: PropTypes.func.isRequired,
    toolTipText: PropTypes.string.isRequired,
    activityCardText: PropTypes.object.isRequired,
    filterButtonText: PropTypes.object.isRequired,
};

export default ActivityPage;



// WEBPACK FOOTER //
// ./src/components/ActivityPage.jsx